import queryString from 'query-string';

export default {
  getQueryParams() {
    return queryString.parse(window.location.search) || {};
  },
};
